export const IMAGE_SHOW_EASE = [0.25, 0.1, 0.15, 1];
export const SHOW_EASE = [0.0, 0.0, 0.47, 0.88];
export const HIDE_EASE = [0.0, 0.0, 0.47, 0.88];
// [0.25, 0.1, 0.25, 1];
/** Time per letter animation at hero title */
export const LETTERS_COLOR_DELAY = 0.15;
/** Time between slide number updates */
export const SLIDE_NUMBER_UPDATE_DELAY = 1.4;
/** Duration for nike logo svg path animation */
export const NIKE_LOGO_DURATION = 3;

/** Period during which slides stay static before changing */
export const SLIDE_STATIC_TIME = 2;
/** Delay before next slide appears */
export const SHOW_DELAY = 1.5;
/** Photos transition duration */
export const IMAGE_SHOW_DURATION = 4;
/** Logo and trademark transition duration */
export const LOGO_SHOW_DURATION = 2;
/** Transition duration for hiding logo and trademark */
export const HIDE_DURATION = 4;

/** Delay periods for showing and hiding photos */
export const IMAGE_DELAY = {
  top: {
    show: 0.2,
    hide: 0.2,
  },
  left: {
    show: 0.4,
    hide: 0.4,
  },
  bottom: {
    show: 0.6,
    hide: 0.2,
  },
  right: {
    show: 0.8,
    hide: 0.7,
  },
};

/** Delay for small "supreme" animation */
export const SUPREME_WORDS_DELAY = 1.6;
/** Time per each small "supreme" animation */
export const SUPREME_WORD_DURATION = 0.4;
/** Transition duration for horizontal supreme logo animation */
export const SUPREME_LOGO_DURATION_X = 8;
/** Transition duration for vertical supreme logo animation */
export const SUPREME_LOGO_DURATION_Y = 2;

/** used for development only to speed up animations */
export const ANIMATION_SPEED_FACTOR = 1;
